import { Box } from "@origin-digital/ods-core";
import { SearchResultItemSkeleton } from "./SearchResultItemSkeleton";

export const SearchResultsSkeleton = (): JSX.Element => (
  <Box
    display="flex"
    flexDirection="column"
    width="full"
    data-id="search-results-skeleton"
  >
    <SearchResultItemSkeleton dataId="search-result-skeleton-1" />
    <SearchResultItemSkeleton dataId="search-result-skeleton-2" />
    <SearchResultItemSkeleton dataId="search-result-skeleton-3" />
  </Box>
);
